import { vars } from "@common/styles";
import styled from "styled-components";

export const CrashesNavigationWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const CrashesNavigationTitle = styled.p`
  max-width: 21rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 0.8rem;
  padding-bottom: 0.1rem;
  color: ${vars.colors.grey10};
  font-weight: 500;
  cursor: default;
`;
